// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hive_f13thi7e{width:100%;}\n.hive_i1twjkup{margin:16px auto auto;}@media (max-height:500px){.hive_i1twjkup{display:none;}}\n", ""]);
// Exports
module.exports = exports;
